import React from "react";
import * as S from "./CardTips.styles";
import Card from "../../../../components/V2/Card/Card";
import colors from "../../../../shared/theme/colors";

const CardTips = () => {
  return (
    <Card backgroundColor={colors.dicaBg}>
      <S.CardTipsContainer>
        <span className="card-tips-title">
          <svg
            className="card-tips-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7.5v5.5" strokeLinecap="round" />
            <circle cx="12" cy="16.5" r="0.6" fill="currentColor" stroke="none" />
          </svg>
          Dica
        </span>

        <span className="card-tips-text">
          Os dados informados devem corresponder ao titular do cartão, mesmo que ele não
          seja o paciente.
        </span>
      </S.CardTipsContainer>
    </Card>
  );
};

export default CardTips;
